var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBlue3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180220",
    "data-name": "Group 180220",
    transform: "translate(-244 -103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146603",
    "data-name": "Rectangle 146603",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(244 103)",
    fill: "#f2f6fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29611",
    "data-name": "Path 29611",
    d: "M4.371,3.371V5.646a.661.661,0,0,1-1.321,0V2.711a.66.66,0,0,1,.661-.661H15.454a.66.66,0,0,1,.661.661h0V5.646a.661.661,0,0,1-1.321,0V3.371h-4.4V16.73h1.768a.661.661,0,0,1,0,1.321H7.02a.661.661,0,0,1,0-1.321H8.775V3.371Z",
    transform: "translate(250.418 108.949)",
    fill: "#203662",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBlue3);
export default __webpack_public_path__ + "static/media/TextBlue (3).d1c621285441916926d9a31e18c8cbac.svg";
export { ForwardRef as ReactComponent };